'use strict';

var GridToolbarSystemStatusFlightReoptController = function GridToolbarSystemStatusFlightReoptController($scope) {
  $scope.selectedRows = [];
  $scope.onRowSelection = function (selectedRows) {
    $scope.selectedRows = selectedRows;
  };
};
GridToolbarSystemStatusFlightReoptController.$inject = ['$scope'];
module.exports = GridToolbarSystemStatusFlightReoptController;